var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBookMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.055 70.9999C141.055 109.435 109.909 140.58 71.4745 140.58C33.0399 140.58 1.89453 109.435 1.89453 70.9999C1.89453 32.5653 33.0399 1.41992 71.4745 1.41992C109.909 1.41992 141.055 32.5653 141.055 70.9999Z",
    fill: "url(#paint0_linear_1545_9257)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8617 33H54.0397C47.9093 33 42.9551 37.9542 42.9551 44.0846V107.384C42.9551 108.026 43.3471 108.596 43.9174 108.846C44.0956 108.917 44.3095 108.953 44.5233 108.953C44.951 108.953 45.3431 108.774 45.6282 108.489L63.4847 90.5971C70.4705 97.5116 80.1294 107.064 81.163 108.24C81.662 108.953 82.6244 109.166 83.3728 108.667C83.6223 108.489 83.8362 108.24 83.9431 107.955C84.05 107.776 84.0857 107.563 84.05 107.384V40.9125C84.05 38.275 86.1885 36.1721 88.7904 36.1721C89.6814 36.1721 90.3586 35.4593 90.3586 34.6039C90.4655 33.7128 89.7527 33 88.8617 33Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4652 33C93.9581 33 96.8094 35.8513 96.8094 39.3442V44.0846C96.8094 44.9756 96.0966 45.6528 95.2412 45.6528H84.1566V39.3442C84.1209 35.8513 86.9723 33 90.4652 33Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5533 86.8191C92.1593 86.8191 99.9465 79.0319 99.9465 69.4259C99.9465 59.8199 92.1593 52.0327 82.5533 52.0327C72.9474 52.0327 65.1602 59.8199 65.1602 69.4259C65.1602 79.0319 72.9474 86.8191 82.5533 86.8191Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3816 77.3385C78.9539 77.3385 78.5619 77.1603 78.2767 76.8752L71.9325 70.5309C71.3266 69.8894 71.3266 68.8914 71.9681 68.2855C72.574 67.6796 73.5364 67.6796 74.1779 68.2855L79.3816 73.4892L90.9296 61.9413C91.5355 61.2997 92.5334 61.2997 93.175 61.9056C93.8165 62.5115 93.8165 63.5095 93.2106 64.1511L93.175 64.1867L80.5222 76.8395C80.2014 77.1603 79.8093 77.3385 79.3816 77.3385Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9257)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.4735,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#98A2B3",
    strokeWidth: 4.07895
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9257",
    x: 42.9551,
    y: 33,
    width: 56.9922,
    height: 77.441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.4884
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.744198
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9257"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9257",
    x: 8.04688,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9257"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9257",
    x1: 23.1945,
    y1: 16.5666,
    x2: 124.725,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookMark);
export default __webpack_public_path__ + "static/media/IconBookMark.383115e224dd878cf9be1badf6463418.svg";
export { ForwardRef as ReactComponent };